const menu = {
  key: "companyInfo",
  route: "/legacy/company-info",
  label: "sidebar.companyInfo",
  icon: "faBuilding",
  group: "system",
  order: 10,
  permission: "legacy.companyInfo.read"
};

export default menu;